// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const useStyles = () => ({
  container: {
    backgroundColor: '#fff',
    borderRight: '2px solid #E3E7EC',
    display: 'flex',
    flexDirection: 'row',
    position: 'absolute',
    zIndex: 1,
    width: '100%',
    border: 'none',
  },
  measurements: {
    backgroundColor: '#fff',
    borderRight: '2px solid #E3E7EC',
    display: 'flex',
    flexDirection: 'row',
  },
  type: {
    display: 'flex',
    flexDirection: 'column',
  },
  typeName: {
    paddingLeft: '10px',
    paddingTop: '10px',
  },
  option: {
    padding: '8px',
    boxShadow: 'none',
    borderRadius: '0px',
  },
  verticalLine: {
    borderLeft: '2px solid #E3E7EC',
  },
  icon: {
    height: '30px',
    width: '30px',
  },
  greyed: {
    opacity: 0.5,
  },
  betaBanner: {
    marginTop: '10px',
    marginLeft: '10px',
    background: 'linear-gradient(90deg, #9038F5 0%, #3C34B7 33.29%, #2075FE 74.06%, #01A1DD 100%)',
    fontSize: '11px',
    padding: '1px 10px',
    color: '#ffffff',
    height: '18px',
  },
  sideBarIcon: {
    width: 24,
    height: 24,
    color: 'rgba(2, 30, 64, 1)',
    transform: 'rotate(180deg)',
  },
  sideBarIconContainer: {
    position: 'absolute',
    top: 100,
    left: 20,
    width: 45,
    height: 45,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    borderRadius: '12px',
    cursor: 'pointer',
    boxShadow: '0px 3px 10px 0px rgba(0, 0, 0, 0.1)',
  },
});

export default useStyles;
